function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.5,17.375 L17.375,17.375 L17.375,15.5 L15.5,15.5 L15.5,17.375 Z M17.75,8.375 L3.875,8.375 L3.875,10.25 L17.75,10.25 L17.75,8.375 Z M17.375,11.75 L15.5,11.75 L15.5,13.625 L17.375,13.625 L17.375,11.75 Z M7.25,5.375 L12.875,5.375 L12.875,3.5 L7.25,3.5 L7.25,0.5 L5.375,0.5 L5.375,6.875 L7.25,6.875 L7.25,5.375 Z M13.625,11.75 L11.75,11.75 L11.75,13.625 L13.625,13.625 L13.625,11.75 Z M16.25,3.5 L16.25,0.5 L14.375,0.5 L14.375,6.875 L16.25,6.875 L16.25,5.375 L19.25,5.375 L19.25,19.25 L2.375,19.25 L2.375,5.375 L3.875,5.375 L3.875,3.5 L0.5,3.5 L0.5,21.125 L21.125,21.125 L21.125,3.5 L16.25,3.5 Z M11.75,17.375 L13.625,17.375 L13.625,15.5 L11.75,15.5 L11.75,17.375 Z M4.25,17.375 L6.125,17.375 L6.125,15.5 L4.25,15.5 L4.25,17.375 Z M6.125,11.75 L4.25,11.75 L4.25,13.625 L6.125,13.625 L6.125,11.75 Z M9.875,11.75 L8,11.75 L8,13.625 L9.875,13.625 L9.875,11.75 Z M8,17.375 L9.875,17.375 L9.875,15.5 L8,15.5 L8,17.375 Z",
  id: "pathb"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "styleGuide7",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-Elements",
  transform: "translate(-180.000000, -2018.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/calendar",
  transform: "translate(179.000000, 2017.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "02.-Icons-/-Basic-UI-/-calendar",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pathb"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  xlinkHref: "#pathb"
})))));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1895C164-B10F-44EC-A037-286B4FE17EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ba7281fd.svg";
export { ForwardRef as ReactComponent };